import { render, staticRenderFns } from "./Protocolo-cobranza.vue?vue&type=template&id=e75f3496&"
import script from "./Protocolo-cobranza.vue?vue&type=script&lang=ts&"
export * from "./Protocolo-cobranza.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports